export default "__VITE_ASSET__BWNkIwAT__"